import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '首页',
      showBottomNav: true
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User.vue'),
    meta: {
      title: '用户中心',
      showBottomNav: true
    }
  },
  {
    path: '/user/info',
    name: 'UserInfo',
    component: () => import('../views/UserInfo.vue'),
    meta: {
      title: '用户信息',
      showBottomNav: false
    }
  },
  {
    path: '/user/stations',
    name: 'MyStations',
    component: () => import('../views/MyStations.vue'),
    meta: {
      title: '我的拟建电站',
      showBottomNav: false
    }
  },
  {
    path: '/ai-re-evaluation',
    name: 'AIReEvaluation',
    component: () => import('../views/AIReEvaluation.vue'),
    meta: {
      title: 'AI复评',
      showBottomNav: false
    }
  },
  {
    path: '/ai-re-evaluation-test',
    name: 'AIReEvaluationTest',
    component: () => import('../views/AIReEvaluationTest.vue'),
    meta: {
      title: 'AI复评测试',
      showBottomNav: false
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router